<template>
	<sheet-expenses :sheet="sheet" class="container-fluid" :anonymous-mode="true"></sheet-expenses>
</template>

<script>
	import SheetExpenses from '../../ui/sheet-expenses.vue';
	import store from '../../core/store';

	export default {
		components: {
			SheetExpenses,
		},
		data () {
			return {
				sheet: store.globals.sheet
			}
		}
	}
</script>

<style>
</style>



// WEBPACK FOOTER //
// src/apps/anonymous/expenses.vue